/**
 * Licensee Cashier Config
 */

define(function(require, exports, module) {
    'use strict';
    var utils = require('utils');
    var _ = require('underscore');
    const cashierConfig = require('portlets/cashier/cashier.config');

    module.exports = function(aspect) {
        const config = cashierConfig();

        var result = {
            ...config,
            Cheque: {
                isGeneric: false,
                withdraw: {
                    isGeneric: true
                }
            },
            Wire: {
                isGeneric: false,
                withdraw: {
                    isGeneric: true
                }
            }
        };

        var applyAspect = function(method, methodType) {
            if (!result[method]) {
                return;
            }

            utils.deepExtend(result[method], result[method][methodType]);
            delete result[method][methodType];
        };

        var extractAspect = function(asp) {
            var split = asp.split('.'),
                method = split[0],
                methodType = split[1];

            if (!method && !methodType) {
                return;
            }

            if (!methodType) {
                result = result[method];
                return;
            }

            if (!method) {
                _.keys(result).forEach(function(mthd) {
                    applyAspect(mthd, methodType);
                });
                return;
            }

            applyAspect(method, methodType);
            result = result[method];
        };

        if (aspect) {
            extractAspect(aspect);
        }

        return result;
    };
});
